// this is a util function to get the indices of the items that should be
// collapsed in the desired collapsing order based on the current wrapper width
// vs total width of all items
export const getCollapsedItemsIndices = ({
  itemWidths,
  itemsIndicesInCollapsingOrder,
  mainWrapperWidth,
}: {
  itemWidths: number[];
  itemsIndicesInCollapsingOrder: number[];
  mainWrapperWidth: number;
}): number[] => {
  const itemsInCollapsingOrder = itemsIndicesInCollapsingOrder.map((index) => {
    if (index < 0 || index >= itemWidths.length)
      throw new Error(
        `Index ${index} is out of bounds for itemWidths array in getCollapsedItemsIndices.`
      );
    return { index, width: itemWidths[index] };
  });
  const itemsTotalWidth = itemWidths.reduce((sum, width) => sum + width, 0);
  const collapsedItemsIndices: number[] = [];

  // keep subtracting item widths in collapsing order from the total width
  // until the total width is less than the main wrapper's width. for each
  // subtraction, we increase the number of collapsed items
  itemsInCollapsingOrder.reduce((totalWidthThreshold, item) => {
    if (totalWidthThreshold >= mainWrapperWidth) {
      collapsedItemsIndices.push(item.index);
      return totalWidthThreshold - item.width;
    }
    return totalWidthThreshold;
  }, itemsTotalWidth);

  return collapsedItemsIndices;
};

// this is a util function to get the collapsing order of breadcrumbs items
// middle items are collapsed first, then the left side items
export const getBreadcrumbsCollapsingOrder = (length: number): number[] => {
  if (length < 1) return [];
  if (length < 2) return [0];
  if (length < 3) return [0, 1];

  // middle items
  const middleItems = Array.from({ length: length - 2 }, (_, i) => i + 1);
  // left side items
  const leftSideItems = [0];
  // active item
  const activeItem = [length - 1];

  return [...middleItems, ...leftSideItems, ...activeItem];
};
